<template>
  <span>
    <jt-data-table ref="table" v-bind="computedProps">
      <template v-slot:body-cell-status="{ props }">
        <q-td :props="props">
          <span v-if="props.value == 'true'">
            <q-icon name="check_circle" color="green" size="1.3rem"> </q-icon>
          </span>
          <span v-else>
            <q-icon name="report_problem" color="red" size="1.3rem"> </q-icon>
          </span>
        </q-td>
      </template>
      <template v-slot:body-cell-edit="{ props }">
        <q-td style="width: 1px" v-if="buttons.length > 0 && rowButtons">
          <span v-for="(button, index) in buttons" :key="index">
            <q-btn
              flat
              small
              class="protocol-close"
              color="primary"
              v-if="filterButton(button, props.row)"
              @click="actionButton(button, props.row)"
            >
              <q-icon :name="iconAction(button)" size="22px" />
              <q-tooltip>{{ button.label }}</q-tooltip>
            </q-btn>
          </span>
        </q-td>
      </template>
    </jt-data-table>
  </span>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtDocs } from 'jtech-webcomps'

@Component({
  name: 'contractItemDataTable',
  mixins: [JtDataTable],
  components: { jtDocsViewer: JtDocs.JtDocsViewer },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
export default class ContractItemDataTable extends Vue {
  get computedFields () {
    if (!this.fields.some((column) => column.name === 'edit')) {
      this.fields.push({
        name: 'edit',
        visibility: 'show',
        label: '',
        model: 'edit'
      })
    }
    return this.fields
  }

  get computedProps () {
    return {
      ...this.$props,
      fields: this.computedFields
    }
  }

  refresh () {
    this.$refs?.table?.refresh()
  }
}
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.red {
  background: #ff000138;
  padding: 7px;
}

.blue {
  background: #7abcce54;
  padding: 7px;
}

.yellow {
  background: #ffd6163b;
  padding: 7px;
}
</style>
